import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import InvoiceImport from './views/invoice/InvoiceImport.vue'
import InvoicePaymentImport from './views/invoice/InvoicePaymentImport.vue'
import SalesOrderImport from './views/invoice/SalesOrderImport.vue'

let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '/',
        component: Home,
        name: 'Menu',
        iconCls: 'el-icon-menu',
        children: [
            {path: '/invoice-import', component: InvoiceImport, name: 'Sales Invoice'},
            {path: '/invoice-payment-import', component: InvoicePaymentImport, name: 'Sales Invoice Payments'},
            {path: '/sales-order-import', component: SalesOrderImport, name: 'Sales Order'},
        ]
    },
    {
        path: '*',
        hidden: true,
        redirect: {path: '/404'}
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js